import React, { useContext, useEffect,useState } from "react"
import { useLocation } from 'react-router-dom'
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import ModalMui from "../core/ModalMui"

import AuthContext from "../../context/authentication/authContext"
import PortalContext from "../../context/portal/portalContext"
import ModalContext from "../../context/modal/modalContext"
import BillContext from "../../context/bill/BillContext"

import useMediaQuery from "../../hooks/useMediaQuery"

import BillsTables from "./BillsTables"

const useStyles = makeStyles((theme) => ({
  billsList: {
    minHeight: "100vh",
    padding:"24px"
  },
  referencesOptionsModal:{
    display:'flex',
    justifyContent:'center',
    flexDirection:'row',
    alignItems: 'center',
  },
  referencesOptionsModalElement:{},
  referencesOptionsModalElementButton:{
   cursor:'pointer',
   margin:"20px",
   padding: "20px",
   fontSize: "14px",
   background:'#001070',
   color:'#ffffff',
   borderRadius:'6px',
   },
  referencesOptionsModalCancel:{
    padding:'20px',
    background: 'rgba(218, 41, 29, 0.86)',
    borderRadius:'6px',
    //marginRight:'15px',
    fontWeight: '500',
    fontSize: '14px',
    //lineHeight: '20px',
    textAlign:'center',
    color:'#ffffff',
    cursor: 'pointer',
  }
}))

const ReferencesOptionsModal=(props)=>{
    function selectReference(event){
        const dt = props.dt
        dt.typesToRefer = parseInt(event.currentTarget.attributes.type.value)
        sessionStorage.setItem('referenceData',JSON.stringify(dt) )
        window.location.href='/app/new-bill'
    }
    return(
        <div className={props.classes.referencesOptionsModal}>
            {
              
                props.data.map((x,k)=>{
                    return(

                        <div className={props.classes.referencesOptionsModalElement} key={k}>
                           <button className={props.classes.referencesOptionsModalElementButton} type={x.typesToRefer} onClick={selectReference}>{x.label}</button>
                        </div>
                    )
                })
            }
           <button className={props.classes.referencesOptionsModalCancel} onClick={props.closeModal}>Cancelar</button>
        </div>
    )
}
const BillsList = (props) => {
  const location = useLocation()
  const authContext = useContext(AuthContext);
  const { authenticatedUser } = authContext;

  const modalContext=useContext(ModalContext)
  const { modalShow, showModal, closeModal ,setModalShow} = modalContext;
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubTitle] = useState("");
  const {exportCompleted,clear } = useContext(BillContext)

  function showReferencesOptions(data,dt){
    setModalTitle("Referenciar Documento")
    setModalSubTitle("Por favor seleccione una opción:")
    setModalContent(<ReferencesOptionsModal data={data} dt={dt} closeModal={closeModal} classes={classes}/>)
    showModal()
  }

  function showExportOk(){
    setModalTitle("Datos envíados correctamente")
    setModalContent(<div style={{display:'flex',justifyContent:'center', width:'100%'}}>
                <button onClick={closeModal} style={{    padding: '10px 20px',
                                                             background: 'rgb(0, 16, 112)',
                                                             borderRadius: '6px',
                                                             marginRight: '15px',
                                                             fontSize: '14px',
                                                             lineHeight: '20px',
                                                             height:'40px',
                                                             textAlign: 'center',
                                                             color: 'rgb(255, 255, 255)',
                                                             width:'180px',
                                                             cursor: 'pointer'}}>Aceptar</button>
                                                             </div>)
    showModal()
  }
  useEffect(() => {
    if(exportCompleted&&exportCompleted=="SI"){
          showExportOk()
    }
  }, [exportCompleted])

  useEffect(() => {
    closeModal()
    if (localStorage.getItem("hasToChange") === "true") {
      props.history.push("/app/change-password?show-terms-of-use=1");
    }
    authenticatedUser();
    const customers = JSON.parse(localStorage.getItem('customers'))
    clear()
   // getBillAll(customers[0].id)
  }, [])




  const classes = useStyles()
  const isMobile = useMediaQuery("max-width", 600)
  return (
    <div
      className={classes.billsList}
    >

         {modalShow &&
              <ModalMui
                modalShow={modalShow}
                showModal={showModal}
                closeModal={closeModal}
                modalTitle={modalTitle}
                
              >
                {modalSubTitle}
                {modalContent}
              </ModalMui>
              }
        <BillsTables showReferencesOptions={showReferencesOptions} setModalTitle={setModalTitle} showModal={showModal}/>
    </div>
  );
};

export default BillsList;
